import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getAgregarAlCarrito({ jsonBody }) {
  const url = `${webservice}/getAgregarAlCarrito`;

  let response = {};

  await superagent
    .post(url)
    .send(jsonBody)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
